import { useState } from 'react';
import { Button, Badge } from '../../components/ui';
import { formatFechaLarga } from '../../utils/fechas';
import ListaTurnosDisponibles from './ListaTurnosDisponibles';
import ModalConfirmarReserva from './ModalConfirmarReserva';
import './Buscar.css';

export default function PasoTurno({ turnos, fecha, criterioLabel, pacienteId, onVolver, onReservado }) {
  const [sel, setSel] = useState(null);

  return (
    <section aria-labelledby="t1">
      <div className="buscar-turno-row" style={{ alignItems: 'baseline' }}>
        <h2 id="t1" style={{ margin: 0 }}>Turnos del {fecha ? formatFechaLarga(fecha) : ''}</h2>
        {criterioLabel && <Badge tone="info">{criterioLabel}</Badge>}
      </div>
      <p className="buscar-muted">Seleccioná un turno para reservarlo.</p>

      <ListaTurnosDisponibles turnos={turnos} onElegir={setSel} />

      <div className="buscar-actions">
        <Button variant="secondary" onClick={onVolver}>← Volver</Button>
        <Button variant="ghost" to="/buscar" onClick={(e) => { e.preventDefault(); onVolver('reiniciar'); }}>
          Cancelar búsqueda
        </Button>
      </div>

      <ModalConfirmarReserva
        turno={sel}
        pacienteId={pacienteId}
        onCerrar={() => setSel(null)}
        onReservado={onReservado}
      />
    </section>
  );
}